import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Benefit } from './models/benefit.model';

export interface BenefitState extends EntityState<Benefit> {
  claimLimit?: number;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'benefit', idKey: 'BenefitId', cache: { ttl: 30000 } })
export class BenefitStore extends EntityStore<BenefitState> {
  constructor() {
    super();
  }

  /** Set the claim limit */
  setLimit(claimLimit: number): void {
    this.update({ claimLimit });
  }
}
